/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useRef } from "react";
import { Modal, Slider, Button } from "antd";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import './index.scss';

const ImageCropUploader = ({
    labelTitle = 'Select a file to upload',
    aspect,
    maxSize = 12,
    onUpload,
    apiUpload,
}) => {
    const imgRef = useRef(null);
    const fileInputRef = useRef(null);
    const [imageSrc, setImageSrc] = useState(null);
    const [preview, setPreview] = useState(null);

    const getDefaultCrop = () => ({
        unit: "%",
        width: 100,
        height: (1 / aspect) * 100,
        x: 0,
        y: (100 - (1 / aspect) * 100) / 2,
        aspect,
    });

    const [crop, setCrop] = useState(getDefaultCrop());



    const [completedCrop, setCompletedCrop] = useState(null);

    const [zoom, setZoom] = useState(1);
    const [rotation, setRotation] = useState(0);

    const [modalOpen, setModalOpen] = useState(false);

    // FILE SELECT
    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const sizeMB = file.size / 1024 / 1024;

        if (sizeMB > maxSize) {
            alert(`File must be smaller than ${maxSize}MB`);
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            setImageSrc(reader.result);
            setModalOpen(true);
        };

        reader.readAsDataURL(file);
    };

    // IMAGE LOAD
    const onImageLoad = (e) => {
        imgRef.current = e.currentTarget;
    };

    // CREATE CROPPED IMAGE
    const getCroppedImage = () => {
        if (!completedCrop || !imgRef.current) return null;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const image = imgRef.current;

        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        canvas.width = completedCrop.width;
        canvas.height = completedCrop.height;

        ctx.save();

        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((rotation * Math.PI) / 180);
        ctx.scale(zoom, zoom);

        ctx.drawImage(
            image,
            completedCrop.x * scaleX,
            completedCrop.y * scaleY,
            completedCrop.width * scaleX,
            completedCrop.height * scaleY,
            -completedCrop.width / 2,
            -completedCrop.height / 2,
            completedCrop.width,
            completedCrop.height
        );

        ctx.restore();

        return canvas.toDataURL("image/png");
    };

    const handleRemovePreview = () => {
        setPreview(null);
        setImageSrc(null);
        setCompletedCrop(null);
    };


    const handleCloseModal = () => {
        setModalOpen(false);
        setCrop(getDefaultCrop());
        setZoom(1);
        setRotation(0);
        setCompletedCrop(null);
    };

    // SAVE CROPPED
    const handleSave = async () => {
        const cropped = getCroppedImage();

        if (!cropped) return;

        setPreview(cropped);
        // setModalOpen(false);
        handleCloseModal();

        if (onUpload) {
            onUpload(cropped);
        }

        if (apiUpload) {
            await apiUpload(cropped);
        }
    };

    return (
        <div>
            {!preview ? (<>

                <span
                    role="button"
                    tabIndex={0}
                    className="uploader-handle"
                    onClick={() => fileInputRef.current.click()}
                    onKeyPress={(e) => e.key === "Enter" && fileInputRef.current.click()}
                    style={{ cursor: "pointer" }}
                >
                    {labelTitle}
                    <input
                        ref={fileInputRef}
                        id="uploadSlot"
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                    />
                </span>

               
            </>) : (
                <div className="uploaderImage-preview">
                    <img
                        src={preview}
                        alt="preview"
                    />
                    <button
                        onClick={handleRemovePreview}
                        style={{
                            position: "absolute",
                            top: 3,
                            right: 3,
                            background: "#ff4d4f",
                            color: "#fff",
                            border: "none",
                            borderRadius: "50%",
                            width: 20,
                            height: 20,
                            cursor: "pointer",
                            fontSize: 11,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        ✕
                    </button>
                </div>
            )}

            {/* Modal */}

            {/* <Modal
                open={modalOpen}
                title="Crop Image"
                // maskClosable={false}
                onCancel={() => setModalOpen(false)}
                footer={null}
                width={700}
                height={250}
            >
                {(modalOpen && <>
                    <div style={{
                        width: '100%',
                        maxWidth: 600,
                        height: 400,
                        margin: '0 auto',
                        position: 'relative',

                    }}>
                        <ReactCrop
                            crop={crop}
                            onChange={(c) => setCrop(c)}
                            onComplete={(c) => setCompletedCrop(c)}
                            aspect={aspect}
                            style={{ height: '100%' }}
                        >
                            <img
                                src={imageSrc}
                                onLoad={onImageLoad}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    transform: `scale(${zoom}) rotate(${rotation}deg)`,
                                }}
                                alt="crop"
                            />
                        </ReactCrop>
                    </div>
                    
                    <div style={styles.controls}>

                        <div style={{ marginBottom: 15 }}>
                            <p htmlFor="zoomRange">Zoom</p>
                            <Slider
                                id="zoomRange"
                                min={1}
                                max={3}
                                step={0.1}
                                value={zoom}
                                onChange={(value) => setZoom(value)}
                            />
                        </div>
                        <div style={{ marginBottom: 15 }}>
                            <p htmlFor="zoomRange">Zoom</p>
                            <Slider
                                id="rotateRange"
                                min={0}
                                max={360}
                                value={rotation}
                                onChange={(value) => setRotation(value)}
                            />
                        </div>

                        <div style={{ display: "flex", gap: 10 }}>

                            <button onClick={handleSave}>
                                Save
                            </button>

                            <button
                                onClick={() => setModalOpen(false)}
                            >
                                Cancel
                            </button>

                        </div>

                    </div>

                </>)}

            </Modal> */}

            <Modal
                open={modalOpen}
                title="Crop Image"
                // onCancel={() => setModalOpen(false)}
                onCancel={handleCloseModal}
                footer={null}
                width={767}
                maskClosable={false}
            >
                {(modalOpen && <>
                    <div className="crop-image-box" style={{ height: 200, }}>
                        <ReactCrop
                            crop={crop}
                            onChange={(c) => setCrop(c)}
                            onComplete={(c) => setCompletedCrop(c)}
                            aspect={aspect}
                            style={{ height: '100%' }}
                        >
                            <img
                                src={imageSrc}
                                onLoad={onImageLoad}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    transform: `scale(${zoom}) rotate(${rotation}deg)`,
                                }}
                                alt="crop"
                            />
                        </ReactCrop>
                    </div>

                    {/* Controls */}
                    <div className="crop-control-box">
                        <div className="each-controlbox">
                            <p>Zoom</p>

                            <Slider
                                id="zoomRange"
                                min={1}
                                max={3}
                                step={0.1}
                                value={zoom}
                                onChange={(value) => setZoom(value)}
                            />
                        </div>
                        <div className="each-controlbox">
                            <p>Rotate</p>
                            <Slider
                                id="rotateRange"
                                min={0}
                                max={360}
                                value={rotation}
                                onChange={(value) => setRotation(value)}
                            />

                        </div>

                    </div>
                    <div className="btn-box">
                        <Button onClick={() => setModalOpen(false)}>Cancel</Button>
                        <Button type="primary" onClick={handleSave}>Save</Button>
                    </div>

                </>)}
            </Modal>

        </div>
    );
};


export default ImageCropUploader;